module.exports = "https://cdn-web.ertelecom.ru/b2c-domru/frontend/_next/static/images/step5-c514526196b9936dde95d1812a6c2214.svg";